const styles = {
  root: {
    border: 0,
    marginTop: 10,
  },
  headerLabel: {
    marginBottom: 3,
  },
  form: {
    paddingTop: 5,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  formError: {
    marginBottom: 3,
  },
  textField: {
    marginBottom: 1,
    width: 300,
  },
  submitButton: {
    width: 200,
    margin: 2,
  },
}
export default styles
